/**
 * The cost-savings amount of a process-improvement observation, as a finite number,
 * or null when the stored value is not a usable amount.
 *
 * `observations.value` is a free-text column shared by every observation type. For
 * pi/general observations it holds a savings amount, but it cannot be formatted
 * directly: stored rows include the literal string "NaN", Angular's CurrencyPipe
 * throws NG02100 on any non-numeric input, and lodash `isNumber(NaN)` is true, so a
 * `isNumber(+value)` check does not exclude it. Currency formatting (`$`, `,`) is
 * tolerated so a formatted amount is not discarded.
 */
export const savingsAmount = (value: unknown): number | null => {
  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : null;
  }
  if (typeof value !== 'string') {
    return null;
  }

  const cleaned = value.replace(/[$,\s]/g, '');
  if (cleaned === '') {
    return null;
  }

  const amount = Number(cleaned);
  return Number.isFinite(amount) ? amount : null;
};
